import { Switch } from 'antd';
import { Text } from '../index';
import { Colors } from '../../config';

const LastSeenSettings = ({ isEnabled, onToggle, loading = false }) => {
  return (
    <div className="flex items-center justify-between flex-1 pl-2">
      <div className="flex flex-col">
        <Text.Basic
          style={{ fontWeight: '600', fontSize: '1rem' }}
          className="text-[#5a6083] dark:text-white"
          text="Last Seen"
        />
      </div>

      <Switch
        checked={isEnabled}
        onChange={() => onToggle(!isEnabled)}
        loading={loading}
        style={{
          backgroundColor: isEnabled ? Colors.MainColor : Colors.borderStrong,
        }}
      />
    </div>
  );
};

export default LastSeenSettings;
